/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CanvasLineController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class CanvasLineController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class CanvasLineController extends cls.ControllerBase /** @lends classes.CanvasLineController.prototype */ {
    static __name = "CanvasLineController";

    _initBehaviors() {
      super._initBehaviors();

      this._addBehavior(cls.CanvasLineParametersVMBehavior);
      this._addBehavior(cls.CanvasFillColorVMBehavior);
      this._addBehavior(cls.CanvasItemOnClickUIBehavior);
    }
  }

  cls.CanvasLineController = CanvasLineController;
  cls.ControllerFactory.register("CanvasLine", cls.CanvasLineController);
});
